import * as React from 'react';
import Home from './containers/minimalism/Home';

const App = () => {
  return <Home />;
};

export default App;
